/**
 * PostHog survey IDs used throughout the app.
 * Each survey is created in the PostHog dashboard (or via API) and referenced here by ID.
 * Override any ID via the corresponding VITE_ environment variable.
 */

export const POSTHOG_SIGNUP_ROLE_SURVEY_ID =
  import.meta.env.VITE_POSTHOG_SIGNUP_ROLE_SURVEY_ID ||
  '019c90d8-a714-0000-ce7a-99b3db33f780';

export const POSTHOG_SLACK_COMMUNITY_SURVEY_ID =
  import.meta.env.VITE_POSTHOG_SLACK_COMMUNITY_SURVEY_ID ||
  '019d64d1-ce1c-0000-db92-15a16d77733f';
